import React from 'react';
import { Modal, Button, Table, Tooltip, Typography, Space } from 'antd';
import { SendOutlined, AmazonOutlined } from '@ant-design/icons';

const { Text } = Typography;

const SendMockupModal = ({ visible, onCancel, onConfirm, mockupReadyOrders, loading }) => {
    const columns = [
        {
            title: '#',
            key: 'index',
            width: 50,
            align: 'center',
            render: (_, record, index) => (
                <Text style={{ fontSize: 12, fontWeight: 'bold' }}>{index + 1}</Text>
            )
        },
        {
            title: 'Order ID',
            dataIndex: 'amazonOrderId',
            key: 'amazonOrderId',
            width: 190,
            render: (text) => (
                <Space>
                    <AmazonOutlined style={{ color: '#FF9900', fontSize: 12 }} />
                    <Text style={{ fontSize: 12 }}>{text}</Text>
                </Space>
            )
        },
        {
            title: 'Order Item ID',
            dataIndex: 'orderItemId',
            key: 'orderItemId',
            width: 160,
            render: (text) => <Text style={{ fontSize: 12 }}>{text}</Text>
        },
        {
            title: 'SKU',
            dataIndex: 'sellerSKU',
            key: 'sellerSKU',
            width: 270,
            render: (text) => <Text style={{ fontSize: 12, fontFamily: 'monospace' }}>{text}</Text>
        },
        {
            title: 'Product Name',
            dataIndex: 'title',
            key: 'title',
            ellipsis: true,
            render: (text) => (
                <Tooltip title={text}>
                    <Text style={{ fontSize: 12 }}>{text}</Text>
                </Tooltip>
            )
        },
        {
            title: 'Customer',
            dataIndex: 'customerName',
            key: 'customerName',
            width: 140,
            render: (text) => <Text style={{ fontSize: 12 }}>{text}</Text>
        }
    ];

    return (
        <Modal
            title={
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <SendOutlined style={{ color: '#1890ff' }} />
                    <span>Send Mockup Confirmation</span>
                </div>
            }
            open={visible}
            onCancel={onCancel}
            footer={[
                <Button key="cancel" onClick={onCancel} disabled={loading}>
                    Cancel
                </Button>,
                <Button 
                    key="submit"
                    type="primary" 
                    icon={<SendOutlined />}
                    onClick={onConfirm}
                    loading={loading}
                >
                    Send Mockup
                </Button>
            ]}
            width='70%'
            styles={{
                body: {
                    padding: '24px'
                }
            }}
        >
            <div style={{ marginBottom: 16 }}>
                <Text>Are you sure you want to send mockup for the following order items?</Text>
                <br />
                <Text type="secondary" style={{ fontSize: 12 }}>
                    Each order will be processed independently in the background. 
                    You can check the status by refreshing the page.
                </Text>
            </div>
            
            <Table
                dataSource={mockupReadyOrders}
                rowKey="id"
                pagination={false}
                size="small"
                columns={columns}
                scroll={{ y: 400 }}
            />
            
            <div style={{ marginTop: 16, padding: 12, backgroundColor: '#f0f8ff', borderRadius: 6 }}>
                <Text strong style={{ color: '#1890ff' }}>
                    Selected Items: {mockupReadyOrders.length}
                </Text>
            </div>
        </Modal>
    );
};

export default SendMockupModal;